import React, { FC } from 'react'

import clsx from 'clsx'
import { useRouter } from 'next/navigation'

import { TableCell, TableRow } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'
import { DateTxt } from 'src/components/molecules'

import { Routes } from 'src/routes'
import { MyReviewingConfirmationEntity } from 'src/types'

type Props = {
  myReviewingConfirmation: MyReviewingConfirmationEntity
  className?: string
}

export const ApprovalRequestTableRow: FC<Props> = ({ myReviewingConfirmation, className }) => {
  const router = useRouter()

  return (
    <TableRow
      align="left"
      className={clsx(
        'tw-h-[3.57rem] tw-bg-background-primary tw-cursor-pointer hover:tw-bg-surface-secondary',
        className
      )}
      onClick={() =>
        router.push(
          Routes.ProjectRoomsWithApplicationDetail.buildPath({
            projectId: myReviewingConfirmation.project.id,
            applicationId: `${myReviewingConfirmation.applicationId}`,
          })
        )
      }
    >
      <TableCell className="tw-border-b tw-border-b-border-primary tw-border-dashed">
        <Txt className="tw-px-s-2 tw-text-right">{myReviewingConfirmation.applicationId}</Txt>
      </TableCell>
      <TableCell className="tw-border-b tw-border-b-border-primary tw-border-dashed">
        <Txt className="tw-px-s-2 tw-break-all">{myReviewingConfirmation.project.name}</Txt>
      </TableCell>
      <TableCell className="tw-border-b tw-border-b-border-primary tw-border-dashed">
        <Txt className="tw-px-s-2">{myReviewingConfirmation.workflowName}</Txt>
      </TableCell>
      <TableCell className="tw-border-b tw-border-b-border-primary tw-border-dashed">
        <Txt className="tw-px-s-2">{myReviewingConfirmation.applicationTitle}</Txt>
      </TableCell>
      <TableCell className="tw-border-b tw-border-b-border-primary tw-border-dashed">
        <Txt className="tw-px-s-1">
          {myReviewingConfirmation.createdBy?.name ??
            myReviewingConfirmation.createdBy?.email ??
            `${myReviewingConfirmation.createdById}（削除済）`}
        </Txt>
      </TableCell>
      <TableCell className="tw-border-b tw-border-b-border-primary tw-border-dashed">
        <div className="tw-text-right tw-px-s0">
          <DateTxt date={myReviewingConfirmation.createdAt} />
          <DateTxt
            date={myReviewingConfirmation.createdAt}
            format="HH:mm:ss"
            sizeType="s"
            className="tw-text-standardText-secondary"
          />
        </div>
      </TableCell>
      <TableCell className="tw-border-b tw-border-b-border-primary tw-border-dashed">
        <div className="tw-text-right tw-px-s0">
          <DateTxt date={myReviewingConfirmation.dueDate} />
          <Txt sizeType="s" className="tw-text-standardText-secondary">
            23:59:59
          </Txt>
        </div>
      </TableCell>
    </TableRow>
  )
}
